import React, {useState} from "react";
import {useDispatch} from "react-redux";
import {showToast} from "../../../redux/slices/toastSlice";
import LoginService from "../../../services/Login";
import {
    FaBitcoin,
    FaDollarSign,
    FaChartLine,
    FaEthereum,
    FaCoins,
    FaSignal,
    FaChartArea,
    FaChartPie,
    FaMoneyBillWave,
    FaArrowTrendUp,
    FaScaleBalanced,
    FaGoogle,
} from "react-icons/fa6";
import {FaExchangeAlt} from "react-icons/fa";
import "./PhoneStep.css";

import {useGoogleLogin} from "@react-oauth/google";
import {body} from "framer-motion/m";

export default function PhoneStep({
                                      authData,
                                      setAuthData,
                                      onNext
                                  }) {
    const dispatch = useDispatch();
    const [loading, setLoading] = useState(false);

    async function onNextBtnClick() {
        if (!authData.email) {
            dispatch(
                showToast({
                    message: "Please fill in all fields correctly",
                    type: "error",
                })
            );
            return;
        }

        const body = {
            email: authData.email,
            password: authData.password,
            fullName: authData.fullName,
        };

        setLoading(true);
        try {
            const res = await LoginService.emailSendOtp(body);
            if (res?.status === 200) {
                dispatch(
                    showToast({
                        message: res?.data?.en_message || "Verification code sent successfully",
                        type: "success",
                    })
                );
                onNext && onNext();
            } else {
                dispatch(
                    showToast({
                        message: res?.data?.en_message || "Unknown server response",
                        type: "error",
                    })
                );
            }
        } catch (err) {
            console.error(err);
            dispatch(
                showToast({
                    message:
                        (err?.data?.en_message) ||
                        err?.en_message ||
                        "Error sending code",
                    type: "error",
                })
            );
        } finally {
            setLoading(false);
        }
    }

    const handleInputChange = (e) => {
        const {name, value} = e.target;
        setAuthData((prev) => ({
            ...prev,
            [name]: value,
        }));
    };

    // Background icons
    const bgIcons = [
        {
            Icon: FaBitcoin,
            className: "text-yellow-300/40",
            style: {top: "6%", left: "4%", animationDelay: "0s", fontSize: 20}
        },
        {
            Icon: FaDollarSign,
            className: "text-white",
            style: {top: "14%", right: "8%", animationDelay: "0.6s", fontSize: 20}
        },
        {
            Icon: FaEthereum,
            className: "text-white/90",
            style: {top: "16%", left: "7%", animationDelay: "1.2s", fontSize: 18}
        },
        {
            Icon: FaChartLine,
            className: "text-white/55",
            style: {top: "20%", right: "6%", animationDelay: "1.8s", fontSize: 26}
        },
        {
            Icon: FaCoins,
            className: "text-white/70",
            style: {bottom: "72%", right: "8%", animationDelay: "0.9s", fontSize: 18}
        },
        {
            Icon: FaSignal,
            className: "text-white/70",
            style: {bottom: "15%", left: "3%", animationDelay: "2.2s", fontSize: 26}
        },
        {
            Icon: FaChartArea,
            className: "text-white/60",
            style: {bottom: "16%", right: "10%", animationDelay: "1.4s", fontSize: 18}
        },
        {
            Icon: FaChartPie,
            className: "text-white/60",
            style: {top: "96%", left: "10%", animationDelay: "2.5s", fontSize: 22}
        },
        {
            Icon: FaMoneyBillWave,
            className: "text-white/60",
            style: {top: "22%", left: "10%", animationDelay: "2.5s", fontSize: 18}
        },
        {
            Icon: FaChartLine,
            className: "text-white/60",
            style: {top: "28%", left: "2%", animationDelay: "1.4s", fontSize: 22}
        },
        {
            Icon: FaExchangeAlt,
            className: "text-white/100",
            style: {top: "90%", left: "2%", animationDelay: "1.8s", fontSize: 15}
        },
        {
            Icon: FaArrowTrendUp,
            className: "text-black",
            style: {top: "90%", left: "92%", animationDelay: "3.5s", fontSize: 15}
        },
        {
            Icon: FaScaleBalanced,
            className: "text-yellow-900/90",
            style: {top: "70%", left: "92%", animationDelay: "4.5s", fontSize: 20}
        },
    ];

    const login = async () => {
        window.location.href = "https://api.7-trade.ir/api/user/v1/google?platform=web"
    }

    return (
        <div className="relative min-h-screen overflow-hidden bg-gray-50 font-inter">
            <div className="gradient-bg">
                <div className="trading-pattern"></div>
                {/* signal waves and floating icons remain the same */}
                {bgIcons.map((it, idx) => {
                    const {Icon, className, style} = it;
                    return (
                        <div
                            key={idx}
                            className={`floating-animation ${className}`}
                            style={{
                                position: "absolute",
                                opacity: idx === 0 ? 0.95 : 0.18,
                                ...style,
                            }}
                        >
                            <Icon/>
                        </div>
                    );
                })}
            </div>

            <div className="relative z-10 flex flex-col items-center justify-center py-4 min-h-full px-6">
                {/* Header / Logo */}
                <div className="text-center animate-fade-in">
                    <div
                        className="inline-flex items-center justify-center w-16 h-16 bg-white rounded-full shadow-lg mb-2 animate-pulse">
                        <FaChartLine className="text-2xl text-blue-600"/>
                    </div>
                    <h1 className="text-2xl font-bold text-white mb-1">7 Trade</h1>
                    <p className="text-blue-100 text-xs">Trade Signal Navigator</p>
                </div>

                <div
                    className="w-[350px] md:w-[500px] max-w-sm bg-white rounded-3xl shadow-2xl p-6 animate-slide-up scale-90">
                    <div className="space-y-6">
                        <div className="text-center mb-6">
                            <h2 className="text-2xl font-bold text-gray-800 mb-2">Sign Up / Login</h2>
                            <p className="text-gray-500 text-sm">Please enter your details</p>
                        </div>

                        {/*<div className="space-y-2">*/}
                        {/*    <label className="text-sm font-bold text-end text-gray-700 block">Full Name</label>*/}
                        {/*    <input*/}
                        {/*        name="fullName"*/}
                        {/*        value={authData.fullName}*/}
                        {/*        onChange={handleInputChange}*/}
                        {/*        placeholder="John Doe"*/}
                        {/*        className="w-full pr-[20px] pl-10 py-4 bg-gray-50 border border-gray-200 rounded-2xl focus:outline-none focus:ring-2 focus:ring-blue-600 focus:border-transparent"*/}
                        {/*    />*/}
                        {/*</div>*/}

                        <div className="space-y-2">
                            <label className="text-sm font-bold text-gray-700 block">Email</label>
                            <input
                                name="email"
                                type="email"
                                value={authData.email}
                                onChange={handleInputChange}
                                placeholder="example@gmail.com"
                                className="w-full pr-[20px] pl-10 py-4 bg-gray-50 border border-gray-200 rounded-2xl focus:outline-none focus:ring-2 focus:ring-blue-600 focus:border-transparent"
                            />
                        </div>

                        {/*<div className="space-y-2">*/}
                        {/*    <label className="text-sm font-bold text-end text-gray-700 block">Password</label>*/}
                        {/*    <div className="relative">*/}
                        {/*        <input*/}
                        {/*            name="password"*/}
                        {/*            type={showPassword ? "text" : "password"}*/}
                        {/*            value={authData.password}*/}
                        {/*            onChange={handleInputChange}*/}
                        {/*            placeholder="Enter password"*/}
                        {/*            className="w-full pr-[20px] pl-10 py-4 bg-gray-50 border border-gray-200 rounded-2xl focus:outline-none focus:ring-2 focus:ring-blue-600 focus:border-transparent"*/}
                        {/*        />*/}
                        {/*        <button*/}
                        {/*            type="button"*/}
                        {/*            onClick={() => setShowPassword(!showPassword)}*/}
                        {/*            className="absolute left-3 top-1/2 -translate-y-1/2 text-gray-400 hover:text-gray-600"*/}
                        {/*        >*/}
                        {/*            {showPassword ? <FaEyeSlash/> : <FaEye/>}*/}
                        {/*        </button>*/}
                        {/*    </div>*/}
                        {/*</div>*/}

                        <button
                            dir="ltr"
                            onClick={onNextBtnClick}
                            disabled={loading || !authData.email}
                            className={`w-full py-4 rounded-2xl font-bold shadow-lg transition-colors duration-300 ${
                                loading || !authData.email
                                    ? "bg-blue-400 opacity-60 text-white"
                                    : "bg-blue-600 hover:bg-blue-700 text-white"
                            }`}
                        >
                            {loading ? "Please wait..." : "Send Verification Code"}
                        </button>

                        {/* Google Login Button */}
                        <div className="flex items-center my-4">
                            <div className="flex-1 border-t border-gray-200"></div>
                            <span className="px-3 text-gray-500 text-sm">or</span>
                            <div className="flex-1 border-t border-gray-200"></div>
                        </div>

                        <button
                            onClick={() => login()}
                            className="w-full bg-white border-2 border-gray-200 text-gray-700 py-3 rounded-2xl font-medium hover:bg-gray-50 transition-colors duration-300 flex items-center justify-center gap-2 shadow-md"
                        >
                            <FaGoogle className="text-red-500 text-md"/>
                            <span dir="rtl">Continue with Gmail</span>
                        </button>
                    </div>
                </div>
            </div>
        </div>
    );
}